import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPublic = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.95101 7.96098L8.00001 11L9.00501 9.00498L13 7.99998L14.182 3.27298M15 17L16 15L13.052 13.019L11.109 12.895L10 14L12 17H15ZM12.813 3.03498C7.18901 2.54598 2.54601 7.18898 3.03501 12.813C3.40701 17.092 6.90701 20.592 11.186 20.964C16.81 21.453 21.453 16.811 20.964 11.186C20.592 6.90798 17.092 3.40798 12.813 3.03498Z",
		stroke: "#111827",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgPublic);
export default ForwardRef;
